class PageTreatments extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'media']
  }

  setupListeners () {
    super.setupListeners()

    if (!window.BAO.MediaBreakpoints.isMd) return

    this.onTriggerHover = this.onTriggerHover.bind(this)
    this.randomMedia = this.randomMedia.bind(this)

    this.els.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, `mouseover`, this.onTriggerHover)
    })
  }

  onTriggerHover (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)

    this.els?.trigger?.elements.forEach((tempEl) => {
      if (tempEl !== triggerEl) {
        tempEl.setAttribute('aria-pressed', 'false')
      }
    })

    triggerEl.setAttribute('aria-pressed', 'true')

    this.classList.add('sec-Treatments-hovered')

    this.randomMedia(triggerEl.dataset.index)
  }

  randomMedia (index) {
    const rollX = Math.random()
    const rollY = Math.random()
    const rollSize = Math.random()

    const isRight = rollX >= 0.5
    const isTop = rollY >= 0.5
    const isLarge = rollSize >= 0.5

    this.els.media.elements.forEach((mediaEl) => {
      if (index === mediaEl.dataset.index) {
        mediaEl.setAttribute('aria-hidden', 'false')
        mediaEl.classList.toggle(
          'sec-Treatments_MediaContainer-large',
          !isLarge,
        )

        mediaEl.style = this.getMediaPosition(isTop, isRight)
      } else {
        mediaEl.setAttribute('aria-hidden', 'true')
      }
    })
  }

  getMediaPosition (isTop, isRight) {
    const topValue = isTop ? `${this.getRandomInt(0, 50)}%` : 'auto'
    const bottomValue = isTop ? 'auto' : `${this.getRandomInt(0, 50)}%`
    const rightValue = isRight ? `${this.getRandomInt(0, 50)}%` : 'auto'
    const leftValue = isRight ? 'auto' : `${this.getRandomInt(0, 50)}%`

    return `--Top: ${topValue}; --Bottom: ${bottomValue}; --Right: ${rightValue}; --Left: ${leftValue};`
  }

  getRandomInt (min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min
  }
}

if (!customElements.get('page-treatments')) {
  customElements.define('page-treatments', PageTreatments)
}
